// extracted by mini-css-extract-plugin
module.exports = {"embedCopyTextarea":"embedCopyTextarea___SWsEU","embedFeedback":"embedFeedback___2jfn0","embedCopied":"embedCopied___MH5w-"};